module.exports = __webpack_public_path__ + "static/media/documents-portal-unauthenticated.d5d4f808.svg";